/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiWallWallItemEntryFromJSON, StreemApiWallWallItemEntryToJSON, } from './';
export function StreemApiWallWallItemEntryEventFromJSON(json) {
    return StreemApiWallWallItemEntryEventFromJSONTyped(json, false);
}
export function StreemApiWallWallItemEntryEventFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'wallItemEntry': !exists(json, 'wall_item_entry') ? undefined : StreemApiWallWallItemEntryFromJSON(json['wall_item_entry']),
        'eventType': !exists(json, 'event_type') ? undefined : json['event_type'],
        'connectionId': !exists(json, 'connection_id') ? undefined : json['connection_id'],
    };
}
export function StreemApiWallWallItemEntryEventToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'wall_item_entry': StreemApiWallWallItemEntryToJSON(value.wallItemEntry),
        'event_type': value.eventType,
        'connection_id': value.connectionId,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiWallWallItemEntryEventEventType;
(function (StreemApiWallWallItemEntryEventEventType) {
    StreemApiWallWallItemEntryEventEventType["ADDED"] = "EVENT_TYPE_ADDED";
    StreemApiWallWallItemEntryEventEventType["DELETED"] = "EVENT_TYPE_DELETED";
    StreemApiWallWallItemEntryEventEventType["INVALID"] = "EVENT_TYPE_INVALID";
    StreemApiWallWallItemEntryEventEventType["UPDATED"] = "EVENT_TYPE_UPDATED";
})(StreemApiWallWallItemEntryEventEventType || (StreemApiWallWallItemEntryEventEventType = {}));
//# sourceMappingURL=StreemApiWallWallItemEntryEvent.js.map